import { Link } from "react-router-dom";
import { Instagram, Linkedin, Facebook, ArrowUpRight } from "lucide-react";
import { SITE, waLink, PROPERTYLAY } from "../lib/data";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#1A1A1A] text-[#FDFBF7] relative overflow-hidden">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-24 pb-12">
      <div className="grid md:grid-cols-12 gap-12">
        <div className="md:col-span-6">
          <p className="overline text-[#C19A6B]">Let's talk</p>
          <h2 className="font-serif-lux text-4xl md:text-6xl mt-4 leading-[1.05] max-w-xl">
            Ready to find the right address?
          </h2>
          <Link
            to="/contact"
            data-testid="footer-cta"
            className="inline-flex items-center gap-3 mt-8 border border-[#C19A6B] text-[#FDFBF7] btn-lux btn-lux-invert px-8 py-4 overline"
          >
            Book a Site Visit <ArrowUpRight size={16} />
          </Link>
        </div>

        <div className="md:col-span-3">
          <p className="overline text-[#5C5C5C] mb-5">Explore</p>
          <ul className="space-y-3 font-sans-lux text-[#E5DFD3]">
            {["Projects", "About", "Insights", "Testimonials", "Contact"].map((l) => (
              <li key={l}>
                <Link to={`/${l.toLowerCase()}`} className="link-sweep hover:text-white">
                  {l}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="overline text-[#5C5C5C] mb-5">Contact</p>
          <ul className="space-y-3 font-sans-lux text-[#E5DFD3] text-sm">
            <li><a href={`tel:${SITE.phoneRaw}`} className="link-sweep">{SITE.phone}</a></li>
            <li><a href={`mailto:${SITE.email}`} className="link-sweep">{SITE.email}</a></li>
            <li><a href={waLink()} target="_blank" rel="noreferrer" className="link-sweep">WhatsApp</a></li>
            <li className="text-[#5C5C5C]">{SITE.location}</li>
          </ul>
          <div className="flex gap-4 mt-6">
            <a href={SITE.socials.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="footer-ig" className="hover:text-[#C19A6B]"><Instagram size={18} /></a>
            <a href={SITE.socials.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn" data-testid="footer-li" className="hover:text-[#C19A6B]"><Linkedin size={18} /></a>
            <a href={SITE.socials.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" data-testid="footer-fb" className="hover:text-[#C19A6B]"><Facebook size={18} /></a>
          </div>
        </div>
      </div>

      <div className="mt-20 pt-8 border-t border-[#333] flex flex-col md:flex-row justify-between gap-6 text-xs text-[#5C5C5C] font-sans-lux">
        <div className="flex flex-col gap-3">
          <p>© {new Date().getFullYear()} Sambhav K. Pandey. All rights reserved.</p>
          <a href={PROPERTYLAY.url} target="_blank" rel="noreferrer" data-testid="footer-propertylay" className="flex items-center gap-3 group">
            <span className="overline text-[#5C5C5C]">In association with</span>
            <img src={PROPERTYLAY.logo} alt="Propertylay" className="h-7 w-auto object-contain bg-[#FDFBF7] px-2 py-1 rounded-sm" loading="lazy" />
          </a>
        </div>
        <p className="max-w-2xl md:text-right">
          Disclaimer: Content is indicative and for information only, not an offer or contract. RERA numbers shown where available; verify all details independently before booking.
        </p>
      </div>
    </div>
  </footer>
);
